import React from 'react'
import './Hobbies.css';
import paint from '../../assets/svg/hobbies/paint.png'
import travel from '../../assets/svg/hobbies/travel.png'
import blog from '../../assets/svg/hobbies/blog.png'

function Hobbies() {
  return (
    
<>
<h1 className='heading'>Hobbies</h1>
<div className="row">
  <div className="column" >
    <img src={paint} className="img"/>
    <p className='desc'>PAINTING</p>
  </div>

  <div className="column" id='column2' >
  <img src={travel} className="img"/>
  <p className='desc'>TRAVELLING</p>
  </div>

  <div className="column">
  <img src={blog} className="img"/>
  <p className='desc'>BLOGGING</p>
  </div>
</div>







</>

  )
}

export default Hobbies